var _style, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlankLines(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 139",
    width: 3,
    height: 139,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Blank Lines-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #050505 } \n\t\t.s2 { fill: #101010 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-505 551.5c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-505 0c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-504.8 413.6c329.7 0 659.4 0 999.1 0q0 0.5 0 1c-329.7 0-659.4 0-999.1 0q0-0.5 0-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-504.5 137.9c329.7 0 659.3 0 999 0q0 0.5 0 1c-329.7 0-659.3 0-999 0q0-0.5 0-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-504.5 275.8c329.6 0 659.2 0 998.8 0q0 0.4 0 0.9c-329.6 0-659.2 0-998.8 0q0-0.4 0-0.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankLines);
export default __webpack_public_path__ + "static/media/BlankLines.f0e57f876b282b63ece3591c9f5ea5ed.svg";
export { ForwardRef as ReactComponent };